// extracted by mini-css-extract-plugin
export default {"wrapper":"UserMessage_wrapper__v6P5U","avatar":"UserMessage_avatar__r4Ssg"};